import { render } from "./OrderDocumentLines.vue?vue&type=template&id=36a4bff4&scoped=true"
import script from "./OrderDocumentLines.vue?vue&type=script&lang=js"
export * from "./OrderDocumentLines.vue?vue&type=script&lang=js"

import "./OrderDocumentLines.vue?vue&type=style&index=0&id=36a4bff4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a4bff4"]])

export default __exports__